import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    container: {
        width: '100%',
        padding: '16px',
        backgroundColor: theme.palette.common.white,
        borderRadius: '6px',
        boxSizing: 'border-box',
        display: 'grid',
        rowGap: '16px',
    },
    description: {
        fontSize: '14px',
        color: '#666',
    },
    section_title: {
        fontSize: '14px',
        fontWeight: 600,
    },
    modes_container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '12px',
    },
    mode_card: {
        textAlign: 'left',
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        padding: '12px',
        backgroundColor: theme.palette.common.white,
        cursor: 'pointer',
        '&:disabled': {
            cursor: 'not-allowed',
        },
    },
    mode_card_selected: {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
    },
    mode_label: {
        fontSize: '14px',
        fontWeight: 600,
    },
    mode_description: {
        fontSize: '12px',
        color: '#666',
        marginTop: '4px',
    },
    fields_container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: '12px',
    },
    logo_container: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    logo_preview: {
        maxHeight: '56px',
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        padding: '4px',
    },
    help_text: {
        fontSize: '12px',
        color: '#999',
    },
    preview_container: {
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        padding: '12px',
        backgroundColor: '#fafafa',
    },
    preview_name: {
        fontSize: '16px',
        fontWeight: 700,
    },
    preview_line: {
        fontSize: '13px',
        fontWeight: 600,
    },
    preview_empty: {
        fontSize: '13px',
        color: '#999',
        fontStyle: 'italic',
    },
    actions_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        borderTop: '1px solid #e0e0e0',
        paddingTop: '16px',
    },
}));

export {useStyles}
